import * as React from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, LinearProgress, Input, InputLabel, MenuItem, FormControl, ListItemText, Select, Checkbox, makeStyles } from '@material-ui/core';
import { TextField } from 'formik-material-ui';
import * as yup from 'yup';
import {Card,CardTitle, Row ,Col,Container} from 'reactstrap'
import emailjs from 'emailjs-com';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }



const initialvalue = {
    Name:'',
    email: '',
    skills: []

}
const vaidation = yup.object({
    email: yup.string().email().required("Required"),
})


const skills = [
    'Coding',
    'Animation',
    'Music',
    'DigitalArt',
    'Contentwriting',
];

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const JoinmeForm = () => {
    const classes = useStyles();

    const [personName, setPersonName] = React.useState([]);
    const [opensucess, setOpensuccess] = React.useState(false);
    const [openerror, setOpenerror] = React.useState(false);
    const handleChange = (event) => {
        setPersonName(event.target.value);
      
    };

    
    const onsubmit = (value,{ setSubmitting }) => {

        
        value.skills=[...personName]
        
        emailjs.send('service_6y2mjlf', 'template_0880plq', value, 'user_CdsZNWus1e4JaXE0ZmevR')
        .then((result) => {
            setSubmitting(false);
            setOpensuccess(true);
            console.log(result.text);
        }, (error) => {
            setOpenerror(true);
            console.log(error.text);
            setSubmitting(false);
        });   
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenerror(false);
        setOpensuccess(false);
      };
    return (<Container>
         <Snackbar open={opensucess} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          Email sent successfully!
        </Alert>
      </Snackbar>
      <Snackbar open={openerror} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error">
          Form submission failed!
        </Alert>
      </Snackbar>
        <Row>
            <Col lg={{size:'6 ', offset:'3'}}>
          
        <Card body outline color="secondary">       
       <CardTitle>
           Apply now
       </CardTitle>
        <Formik
            initialValues={initialvalue}
            validationSchema={vaidation}
            onSubmit={onsubmit
            }

        >{

            formik=>{
              
                return(
     
                    <Form >
                        <Field
                            component={TextField}
                            name="Name"
                            type="text"
                            label="Name"
                            fullWidth
                        /><br />
                        <Field
                            component={TextField}
                            name="email"
                            type="email"
                            label="Email"
                            fullWidth
                        />
                        <br />
     
                        <FormControl className={classes.formControl}   fullWidth>
                            <InputLabel id="demo-mutiple-checkbox-label">Skills</InputLabel>
                            <Select
                                labelId="demo-mutiple-checkbox-label"
                                id="demo-mutiple-checkbox"
                                multiple
                                value={personName}
                                onChange={handleChange}
                                input={<Input />}
                                renderValue={(selected) => selected.join(', ')}
                                MenuProps={MenuProps}
                            >
                                {skills.map((name) => (
                                    <MenuItem key={name} value={name}>
                                        <Checkbox checked={personName.indexOf(name) > -1} />
                                        <ListItemText primary={name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <br></br>
                        {formik.isSubmitting && <LinearProgress />}
                        <br />
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={formik.isSubmitting}
                            onClick={formik.submitForm}
                        >
                            Join
              </Button>
                    </Form>
                )}
        }
        
           
        </Formik>
      
      </Card>
      </Col>
        </Row>
    </Container>
    );
}
export default JoinmeForm